<template>
  <div>
    <plan-limit-modal
      :show="showPlanLimitModal"
      :on-close="() => (showPlanLimitModal = false)"
      :description="$t('INBOX_MGMT.PLAN_LIMIT.DESCRIPTION')"
      :link-text="$t('INBOX_MGMT.PLAN_LIMIT.LINK_TEXT')"
    />
    <div class="row whatsapp-pin-section">
      <div class="medium-8 columns">
        <div class="callout alert whatsapp-pin-callout">
          <strong>{{ $t('INBOX_MGMT.ADD.WHATSAPP.TWO_STEP_PIN.WARNING_TITLE') }}</strong>
          <p>{{ $t('INBOX_MGMT.ADD.WHATSAPP.TWO_STEP_PIN.WARNING_BODY') }}</p>
        </div>
        <label :class="{ error: $v.twoStepPin.$error }">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.TWO_STEP_PIN.LABEL') }}
          <input
            v-model.trim="twoStepPin"
            type="text"
            inputmode="numeric"
            maxlength="6"
            autocomplete="off"
            :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.TWO_STEP_PIN.PLACEHOLDER')"
            @blur="$v.twoStepPin.$touch"
          />
          <span v-if="$v.twoStepPin.$error" class="message">
            {{ $t('INBOX_MGMT.ADD.WHATSAPP.TWO_STEP_PIN.ERROR') }}
          </span>
        </label>
        <p class="whatsapp-pin-hint">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.TWO_STEP_PIN.HINT') }}
        </p>
      </div>
    </div>

    <woot-submit-button
      :button-text="$t('INBOX_MGMT.ADD.WHATSAPP.ONBOARDING')"
      @click="startOnboard"
    />
    <form class="row" @submit.prevent="createChannel()">
      <div class="medium-8 columns">
        <label :class="{ error: $v.inboxName.$error }">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.LABEL') }}
          <input
            v-model.trim="inboxName"
            type="text"
            :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.PLACEHOLDER')"
            @blur="$v.inboxName.$touch"
          />
          <span v-if="$v.inboxName.$error" class="message">
            {{ $t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.ERROR') }}
          </span>
        </label>
      </div>

      <div class="medium-8 columns">
        <label :class="{ error: $v.phoneNumber.$error }">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER.LABEL') }}
          <input
            v-model.trim="phoneNumber"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER.PLACEHOLDER')
            "
            @blur="$v.phoneNumber.$touch"
          />
          <span v-if="$v.phoneNumber.$error" class="message">
            {{ $t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER.ERROR') }}
          </span>
        </label>
      </div>

      <div class="medium-8 columns">
        <label :class="{ error: $v.phoneNumberId.$error }">
          <span>
            {{ $t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER_ID.LABEL') }}
          </span>
          <input
            v-model.trim="phoneNumberId"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER_ID.PLACEHOLDER')
            "
            @blur="$v.phoneNumberId.$touch"
          />
          <span v-if="$v.phoneNumberId.$error" class="message">
            {{ $t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER_ID.ERROR') }}
          </span>
        </label>
      </div>

      <div class="medium-8 columns">
        <label :class="{ error: $v.businessAccountId.$error }">
          <span>
            {{ $t('INBOX_MGMT.ADD.WHATSAPP.BUSINESS_ACCOUNT_ID.LABEL') }}
          </span>
          <input
            v-model.trim="businessAccountId"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.WHATSAPP.BUSINESS_ACCOUNT_ID.PLACEHOLDER')
            "
            @blur="$v.businessAccountId.$touch"
          />
          <span v-if="$v.businessAccountId.$error" class="message">
            {{ $t('INBOX_MGMT.ADD.WHATSAPP.BUSINESS_ACCOUNT_ID.ERROR') }}
          </span>
        </label>
      </div>

      <div class="medium-8 columns">
        <label :class="{ error: $v.apiKey.$error }">
          <span>
            {{ $t('INBOX_MGMT.ADD.WHATSAPP.API_KEY.LABEL') }}
          </span>
          <input
            v-model.trim="apiKey"
            type="text"
            :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.API_KEY.PLACEHOLDER')"
            @blur="$v.apiKey.$touch"
          />
          <span v-if="$v.apiKey.$error" class="message">
            {{ $t('INBOX_MGMT.ADD.WHATSAPP.API_KEY.ERROR') }}
          </span>
        </label>
      </div>

      <div class="medium-12 columns">
        <woot-submit-button
          :loading="uiFlags.isCreating"
          :button-text="$t('INBOX_MGMT.ADD.WHATSAPP.SUBMIT_BUTTON')"
        />
      </div>
    </form>
  </div>
</template>

<script>
import { isNumber, isPhoneE164OrEmpty } from 'shared/helpers/Validators';
import alertMixin from 'shared/mixins/alertMixin';
import planLimitMixin from 'dashboard/mixins/planLimitMixin';
import { required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';
import router from '../../../../index';
import PlanLimitModal from 'dashboard/components/widgets/modal/PlanLimitModal';
import { ensureFacebookSdk } from 'dashboard/helper/facebookSdk';

export default {
  components: { PlanLimitModal },
  mixins: [alertMixin, planLimitMixin],
  data() {
    return {
      inboxName: '',
      phoneNumber: '',
      apiKey: '',
      phoneNumberId: null,
      businessAccountId: null,
      twoStepPin: '051993',
    };
  },
  mounted() {
    ensureFacebookSdk({
      appId: window.chatwootConfig.wbAppId,
      version: 'v20.0',
    }).catch(() => {});

    window.addEventListener('message', event => {
      if (
        event.origin !== 'https://www.facebook.com' &&
        event.origin !== 'https://web.facebook.com'
      ) {
        return;
      }

      try {
        const data = JSON.parse(event.data);
        if (data.type === 'WA_EMBEDDED_SIGNUP') {
          if (data.event === 'FINISH') {
            const { phone_number_id, waba_id } = data.data;
            this.phoneNumberId = Number(phone_number_id);
            this.businessAccountId = Number(waba_id);
          }
        }
      } catch {
        console.log('Non JSON Response', event.data);
      }
    });
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
      getAccount: 'accounts/getAccount',
      currentAccountId: 'getCurrentAccountId',
    }),
  },
  validations: {
    inboxName: { required },
    phoneNumber: { required, isPhoneE164OrEmpty },
    apiKey: { required },
    phoneNumberId: { required, isNumber },
    businessAccountId: { required, isNumber },
    twoStepPin: {
      required,
      isSixDigitPin(value) {
        return /^\d{6}$/.test(value || '');
      },
    },
  },
  methods: {
    waitForPhoneNumberId(timeoutMs = 15000) {
      if (this.phoneNumberId) {
        return Promise.resolve(this.phoneNumberId);
      }

      return new Promise((resolve, reject) => {
        const startedAt = Date.now();
        const intervalId = setInterval(() => {
          if (this.phoneNumberId) {
            clearInterval(intervalId);
            resolve(this.phoneNumberId);
            return;
          }

          if (Date.now() - startedAt >= timeoutMs) {
            clearInterval(intervalId);
            reject(new Error('phone_id_timeout'));
          }
        }, 100);
      });
    },

    onboardErrorMessage(error) {
      const metaMessage =
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        error?.message;

      if (metaMessage === 'phone_id_timeout') {
        return this.$t('INBOX_MGMT.ADD.WHATSAPP.API.ONBOARD_PHONE_ID_TIMEOUT');
      }

      if (typeof metaMessage === 'string' && metaMessage.length && metaMessage !== 'phone_id_timeout') {
        return metaMessage;
      }

      return this.$t('INBOX_MGMT.ADD.WHATSAPP.API.ONBOARD_ERROR_MESSAGE');
    },

    async completeOnboard(code) {
      try {
        const phoneId = await this.waitForPhoneNumberId();
        const data = await this.$store.dispatch('createOnboard', {
          code,
          phone_id: phoneId,
          pin: this.twoStepPin,
        });

        this.apiKey = data.access_token;
        this.phoneNumber = data.phone_number;
      } catch (error) {
        console.error('Error on Request Meta:', error);
        this.showAlert(this.onboardErrorMessage(error));
      }
    },

    async startOnboard() {
      this.$v.twoStepPin.$touch();
      if (this.$v.twoStepPin.$invalid) {
        this.showAlert(this.$t('INBOX_MGMT.ADD.WHATSAPP.TWO_STEP_PIN.ERROR'));
        return;
      }

      try {
        const FB = await ensureFacebookSdk({
          appId: window.chatwootConfig.wbAppId,
          version: 'v20.0',
        });

        FB.login(
          response => {
            if (response?.authResponse?.code) {
              this.completeOnboard(response.authResponse.code);
            }
          },
          {
            config_id: window.chatwootConfig.wbConfigId,
            response_type: 'code',
            override_default_response_type: true,
            extras: {
              feature: 'whatsapp_embedded_signup',
              version: 2,
              sessionInfoVersion: 2,
            },
          }
        );
      } catch (error) {
        console.error('Error initializing Facebook SDK for WhatsApp:', error);
      }
    },

    async createChannel() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      try {
        const account = this.getAccount(this.currentAccountId);
        const whatsappChannel = await this.$store.dispatch(
          'inboxes/createChannel',
          {
            name: this.inboxName,
            channel: {
              type: 'whatsapp',
              phone_number: this.phoneNumber,
              provider: 'whatsapp_cloud',
              provider_config: {
                api_key: this.apiKey,
                phone_number_id: this.phoneNumberId,
                business_account_id: this.businessAccountId,
              },
            },
          }
        );

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: whatsappChannel.inbox.id,
          },
        });
      } catch (error) {
        if (this.handlePlanLimitError(error)) return;
        this.showAlert(this.$t('INBOX_MGMT.ADD.WHATSAPP.API.ERROR_MESSAGE'));
      }
    },
  },
};
</script>

<style scoped lang="scss">
.whatsapp-pin-section {
  margin-bottom: var(--space-normal);
}

.whatsapp-pin-callout {
  margin-bottom: var(--space-small);
  border-left: 4px solid var(--r-500);
  font-size: var(--font-size-small);

  strong {
    display: block;
    margin-bottom: var(--space-smaller);
    font-size: var(--font-size-default);
    text-transform: uppercase;
    letter-spacing: 0.02em;
  }

  p {
    margin: 0;
    line-height: 1.45;
  }
}

.whatsapp-pin-hint {
  margin-top: var(--space-smaller);
  color: var(--s-600);
  font-size: var(--font-size-mini);
  line-height: 1.4;
}
</style>
